import { Controller } from '@hotwired/stimulus'

import '../../../css/log/log.scss'
import 'jquery-ui-sortable-npm'
import 'semantic-ui-checkbox/checkbox.min'
import 'semantic-ui-dropdown/dropdown.min'
import 'semantic-ui-dropdown/dropdown.min.css'
import 'semantic-ui-transition/transition.min.js'
import 'semantic-ui-transition/transition.min.css'
import 'semantic-ui-api/api.js'
import 'semantic-ui-search/search.min.js'
import 'semantic-ui-form/form.min.js'
import 'tempusdominus-bootstrap-4/build/css/tempusdominus-bootstrap-4.min.css'

global.moment = require('moment')
require('tempusdominus-bootstrap-4')
$.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
  icons: {
    time: 'far fa-clock',
    date: 'far fa-calendar',
    up: 'far fa-arrow-up',
    down: 'far fa-arrow-down',
    previous: 'far fa-chevron-left',
    next: 'far fa-chevron-right',
    today: 'far fa-calendar-check-o',
    clear: 'far fa-trash',
    close: 'far fa-check'
  }
})

export default class extends Controller {
  static values = {
    entityType: String,
    timingCount: Number,
    selectedTimings: Array
  }

  static targets = [
    'timings', 'timingTemplate',
    'logEventDropdown', 'logRelativeEventDropdown'
  ]

  connect () {
    if (this.entityTypeValue === 'logTemplate') {
      $(this.timingsTarget).sortable({
        handle: '.handle'
      })
    } else if (this.entityTypeValue === 'log') {
      this.reorderTimings()
    }
  }

  add () {
    const newTiming = this.timingTemplateTarget.cloneNode(true)
    newTiming.removeAttribute('data-log-timings-target')
    newTiming.classList.add('timing')
    newTiming.classList.remove('d-none')

    const newId = 'datetimepicker-day-' + this.element.dataset.day + '-timing-' + this.timingCountValue
    const absoluteTimeInput = newTiming.querySelector('.datetimepicker')
    absoluteTimeInput.setAttribute('id', newId)
    Array.from(absoluteTimeInput.children).forEach(child => {
      child.dataset.target = '#' + newId
    })

    this.timingsTarget.appendChild(newTiming)
    this.timingCountValue += 1
  }

  enableEventDropdownOptions (timingId) {
    this.logEventDropdownTargets.forEach(dropdown => {
      dropdown.querySelectorAll('.menu .item').forEach(option => {
        if (option.dataset.value === timingId) {
          option.classList.remove('disabled')
        }
      })
    })
  }

  disableEventDropdownOptions (timingId) {
    this.logEventDropdownTargets.forEach(dropdown => {
      const timing = dropdown.closest('.row')
      if (timing.dataset.timingId === timingId) {
        return
      }

      dropdown.querySelectorAll('.menu .item').forEach(option => {
        if (option.dataset.value === timingId) {
          option.classList.add('disabled')
        }
      })
    })
  }

  addToRelatedEventDropdowns (timingId, newItem) {
    this.logRelativeEventDropdownTargets.forEach(dropdown => {
      const timing = dropdown.closest('.row')
      if (timing.dataset.timingId === timingId) {
        return
      }

      if (!dropdown.querySelector('.menu .item[data-value="' + timingId + '"]')) {
        dropdown.querySelector('.menu').insertAdjacentHTML('beforeend', newItem)
        $(dropdown).dropdown('refresh')
      }
    })
  }

  removeFromRelatedEventDropdowns (timingId) {
    this.logRelativeEventDropdownTargets.forEach(dropdown => {
      dropdown.querySelectorAll('.item').forEach(option => {
        if (option.dataset.value === timingId) {
          option.remove()
          $(dropdown).dropdown('refresh')
        }
      })
    })
  }

  clearRelatedEventDropdowns (timingId) {
    this.logRelativeEventDropdownTargets.forEach(dropdown => {
      const relativeTimingId = $(dropdown).dropdown('get value')
      if (relativeTimingId === timingId) {
        $(dropdown).dropdown('clear')
      }

      dropdown.querySelectorAll('.menu .item').forEach(item => {
        if (item.dataset.value === timingId) {
          item.remove()
        }
      })
    })
  }

  getAbsoluteTimeInMinutes (absoluteTimingId) {
    const absoluteTiming = document.querySelector('.timing[data-timing-id="' + absoluteTimingId + '"]')
    if (absoluteTiming) {
      const occursAtInMinutes = parseInt(absoluteTiming.dataset.occursAtInMinutes)
      return (isNaN(occursAtInMinutes)) ? null : occursAtInMinutes
    }

    return null
  }

  calculateAllOccursAt () {
    Array.from(this.timingsTarget.children).forEach(timing => {
      this.application.getControllerForElementAndIdentifier(timing, 'log-timing').calculateOccursAt()
    })

    this.reorderTimings()
  }

  reorderTimings () {
    if (this.entityTypeValue === 'logTemplate') {
      return
    }

    const rows = Array.from(this.timingsTarget.getElementsByClassName('row'))
    rows.sort((a, b) => {
      return parseInt(a.dataset.occursAtInMinutes) - parseInt(b.dataset.occursAtInMinutes)
    })

    this.timingsTarget.innerHTML = ''
    rows.forEach(row => this.timingsTarget.appendChild(row))
  }
}
